import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=687c9346&scoped=true"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"
import style0 from "./Setup.vue?vue&type=style&index=0&id=687c9346&prod&lang=scss&scoped=true"
import style1 from "./Setup.vue?vue&type=style&index=1&id=687c9346&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c9346",
  null
  
)

export default component.exports